import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from './Dialog';
import { useHotkey, useShortcutList, type Shortcut, type ShortcutGroup } from './hotkeys';
import { Kbd } from './Kbd';

const ORDER: ShortcutGroup[] = ['general', 'lists', 'page'];

/** The `?` cheat sheet: every shortcut available right now, grouped. */
export function ShortcutsDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const shortcuts = useShortcutList();
  useHotkey('?', () => setOpen(true), { description: t('shortcuts.show'), group: 'general' });

  const groups = new Map<ShortcutGroup, Shortcut[]>();
  for (const s of shortcuts) groups.set(s.group, [...(groups.get(s.group) ?? []), s]);
  const names = [...groups.keys()].sort((a, b) => ORDER.indexOf(a) - ORDER.indexOf(b));

  return (
    <Dialog open={open} onOpenChange={setOpen} title={t('shortcuts.title')} description={t('shortcuts.description')} size="sm">
      <div className="flex flex-col gap-4">
        {names.map((name) => (
          <section key={name}>
            <h3 className="m-0 mb-1 text-xs font-bold uppercase tracking-wide text-ink-muted">{t(`shortcuts.groups.${name}`)}</h3>
            <ul className="m-0 list-none p-0">
              {groups.get(name)!.map((s) => (
                <li key={s.keys} className="flex items-center justify-between gap-4 border-b border-line py-1.5 text-sm last:border-0">
                  <span>{s.description}</span>
                  <Kbd keys={s.keys} />
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
